"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fmko_ts_common_1 = require("fmko-ts-common");
const ImageWidget_1 = tslib_1.__importStar(require("./ImageWidget"));
const MessageBar_1 = tslib_1.__importDefault(require("./MessageBar"));
class AttentionBar extends MessageBar_1.default {
    constructor() {
        super();
    }
    getIcon() {
        return new ImageWidget_1.default({
            alt: "Bemærk",
            imageDimension: ImageWidget_1.ImageDimensions.XL,
            src: fmko_ts_common_1.ImageSrcWithVersion.getImage(fmko_ts_common_1.ImageSrc.ATTENTION)
        });
    }
}
exports.default = AttentionBar;
//# sourceMappingURL=AttentionBar.js.map